export const FAQ = 'NIKE RSL FAQ';
export const FEEDBACK = 'FEEDBACK';
export const TERMS = 'TERMS & CONDITIONS';
export const POLICIES = 'POLICIES';
export const CONTACT = 'CONTACT';
export const NIKEINC = '2025 Nike, Inc. All Rights Reserved';
export const appVERSION = 'Version - 2.1.0';

